import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const deleteModalCategorySlice = createSlice({
  name: "deleteModalCategory",
  initialState,
  reducers: {
    openModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModalDelete, closeModalDelete } = deleteModalCategorySlice.actions;
export default deleteModalCategorySlice.reducer;
